import { fetchLocale } from 'actions/localization';
import { intializeClosedCaptionSettings } from 'actions/closedCaptionSettings';
import { AppDispatch } from 'app-types';
import { VideoCtvRedux } from 'store-types';

export const START_UP = 'APP_START_UP' as const;
export const START_UP_LOADING = 'APP_START_UP_LOADING' as const;
export const START_UP_COMPLETE = 'APP_START_UP_COMPLETE' as const;
export const START_UP_ERROR = 'APP_START_UP_ERROR' as const;

export const startUpComplete = () => ({
  type: START_UP_COMPLETE,
});

export const startUpError = () => ({
  type: START_UP_ERROR,
});

// Failed actions will return false because the promise middleware resolves failed actions as false
const hasAnyActionFailed = (responses: unknown[]) => responses.findIndex(item => !item) > -1;

export const startUp = () => async (dispatch: AppDispatch<VideoCtvRedux>) => {
  return dispatch(fetchLocale())
    .then(() => {
      const fetchClosedCaptionSettingsPromise = dispatch(
        intializeClosedCaptionSettings(),
      );

      const requiredPromises = [];
      const optionalPromises = [fetchClosedCaptionSettingsPromise];
      return Promise.all([
        ...requiredPromises,
        Promise.allSettled(optionalPromises),
      ]);
    })
    .then(res => {
      if (hasAnyActionFailed(res)) {
        return dispatch(startUpError());
      }

      return dispatch(startUpComplete());
    })
    .catch(() => {
      dispatch(startUpError());
    });
};
